import { Col, Container, Row } from "react-bootstrap";
import {
  ArrowLeftCircle,
  PersonCircle,
  PiggyBank,
  Receipt,
  BarChart,
} from "react-bootstrap-icons";
import { Outlet } from "react-router-dom";
import { useParamIds } from "./Data/Common";
import { PageTitle } from "./Controls/PageTitle";
import { CollapsibleSidebar } from "./Controls/CollapsibleSidebar";
import { CollapsibleMenuItem } from "./Controls/CollapsibleMenuItem";

export function AppFacilityFinance() {
  const { facilityId } = useParamIds();

  const PiggyBankIcon = () => (
    <PiggyBank className="fs-3" style={{ transform: "scaleX(-1)" }} />
  );

  return (
    <Container fluid className="fullheight pt-2">
      <div className="d-flex fullheight">
        <CollapsibleSidebar 
          className="d-print-none"
          header={
            <PageTitle className="fw-normal">Finance</PageTitle>
          }
        >
          <CollapsibleMenuItem special icon={<ArrowLeftCircle />} default to={`/facility/${facilityId}`} text="Back to Facility" />
          <CollapsibleMenuItem icon={<PersonCircle />} default to="./overview" text="Overview" />
          <CollapsibleMenuItem icon={<Receipt />} to="./invoice" text="Invoices" />
          <CollapsibleMenuItem icon={<PiggyBankIcon />} to="./payout" text="Payouts" />
        </CollapsibleSidebar>
        <div className="fullheight scroll-y-auto flex-fill">
          <Outlet />
        </div>
      </div>
    </Container>
  );
}